/**
 * index.ts - System preference modules
 * 
 * CHANGE HISTORY:
 * - 251031_1540 [pending] danielbeer: Added actr module
 * - 251023_1854 [pending] danielbeer: Initial creation
 */

export { skinnrModule } from './skinnr';
export { authrModule } from './authr';
export { notifyrModule } from './notifyr';
export { loggrModule } from './loggr';
export { actrModule } from './actr';

// Export all system modules as array
import { skinnrModule } from './skinnr';
import { authrModule } from './authr';
import { notifyrModule } from './notifyr';
import { loggrModule } from './loggr';
import { actrModule } from './actr';

export const systemModules = [
  skinnrModule,
  authrModule,
  notifyrModule,
  loggrModule,
  actrModule
];

export default systemModules;
